import SportCode from 'components/common/SportCode'
import { findArray } from 'helpers/utils'
import Label from "components/general/Label"
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import {
  faStop
} from "@fortawesome/free-solid-svg-icons";


// Renders two tables to show acumulated penalty cards from each competitor and coach
export const Warnings = ({ data }) => {
  const { mirs_discipline, mirs_rsc } = useUrlFriendlyToParameters();
  const home = data?.results?.items?.find(i => i.startSortOrder === 1)?.extendedResults;
  const away = data?.results?.items?.find(i => i.startSortOrder === 2)?.extendedResults;
  const yc = <FontAwesomeIcon className="text-warning" icon={faStop} />
  const rc = <FontAwesomeIcon className="text-danger" icon={faStop} />
  const bc = <FontAwesomeIcon icon={faStop} />
  return (
    <div className="warnings-main" id={`table-warnings-${mirs_rsc}`}>
      <Table bordered className="table-warnings">
        <caption><Label data={'WarningsT1'} sport={mirs_discipline} /></caption>
        <tbody>
          <tr role="row">
            <td className="col-2 text-start">{yc} <Label data={'LabelYellowCards'} />:</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['YC_NUM'], er_pos: ['COMPETITOR'] })?.er_value}</td>
            <td className="col-5 text-start">{findArray(away, { er_type: ['ER'], er_code: ['YC_NUM'], er_pos: ['COMPETITOR'] })?.er_value}</td>
          </tr>
          <tr role="row">
            <td className="col-2 text-start">{rc} <Label data={'LabelRedCards'} />:</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['RC_NUM'], er_pos: ['COMPETITOR'] })?.er_value}</td>
            <td className="col-5 text-start">{findArray(away, { er_type: ['ER'], er_code: ['RC_NUM'], er_pos: ['COMPETITOR'] })?.er_value}</td>
          </tr>
          <tr role="row">
            <td className="col-2 text-start">{bc} <Label data={'LabelBlackCards'} />:</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['BC_NUM'], er_pos: ['COMPETITOR'] })?.er_value}</td>
            <td className="col-5 text-start">{findArray(away, { er_type: ['ER'], er_code: ['BC_NUM'], er_pos: ['COMPETITOR'] })?.er_value}</td>
          </tr>
        </tbody>
      </Table>
      <Table bordered className="table-warnings">
        <caption><Label data={'WarningsT2'} sport={mirs_discipline} /></caption>
        <tbody>
          <tr role="row">
            <td className="col-2 text-start">{yc} <Label data={'LabelYellowCards'} />:</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['YC_NUM'], er_pos: ['COACH'] })?.er_value}</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['YC_NUM'], er_pos: ['COACH'] })?.er_value}</td>
          </tr>
          <tr role="row">
            <td className="col-2 text-start">{bc} <Label data={'LabelBlackCards'} />:</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['BC_NUM'], er_pos: ['COACH'] })?.er_value}</td>
            <td className="col-5 text-start">{findArray(home, { er_type: ['ER'], er_code: ['BC_NUM'], er_pos: ['COACH'] })?.er_value}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

// Renders a colored card and action text in play by play action.
export const ActionTag = ({ className, action, cardSide }) => {
  const { breakPoint } = useViewport();
  const { mirs_discipline } = useUrlFriendlyToParameters()
  if (cardSide === 'R') {
    return (<>
      {(breakPoint !== "sm" && breakPoint !== "xs") && <SportCode discipline={mirs_discipline} entity='@Action' code={action} />} <FontAwesomeIcon className={className} icon={faStop} />
    </>)
  }
  return (<>
    <FontAwesomeIcon className={className} icon={faStop} /> {(breakPoint !== "sm" && breakPoint !== "xs") && <SportCode discipline={mirs_discipline} entity='@Action' code={action} />}
  </>)
}  
